import type { BlogPost, Image } from "~/types";

type ImageSize = 'thumbnail' | 'large' | 'full';
type SourceImage = Required<Omit<Image, 'alt'>>;
interface GetPostsOptions {
  search?: string;
  category?: number;
  author?: number;
  page?: number;
  perPage?: number;
  exclude?: BlogPost['id'];
}

export function buildGetPostsUrl(base: string, options: GetPostsOptions = {}) {
  const { search, category, author, exclude, page = 1, perPage = 100 } = options;
  let query = `${base}/posts?page=${page}&per_page=${perPage}&_embed=1`;
  if (category) {
    query += `&categories=${category}`;
  }
  if (search) {
    query += `&search=${search}`;
  }
  if (author) {
    query += `&author=${author}`;
  }
  if (exclude) {
    query += `&exclude=${exclude}`;
  }
  return query;
}

export function buildGetPostUrl(base: string, slug: string) {
  return `${base}/posts?slug=${slug}&per_page=1&_embed=1`;
}

export function buildGetCatgoriesUrl(base: string) {
  return `${base}/categories?per_page=100`;
}

export function buildGetCatgoryUrl(base: string, slug: string) {
  return `${base}/categories?slug=${slug}`;
}

export function buildGetAuthorUrl(base: string, id: string) {
  return `${base}/users/${id}`;
}

export function buildCategoryUrl(slug: string) {
  return `/blog/category/${slug}`;
}

export function buildBlogBaseUrl(domain: string) {
  return `https://${domain}/wp-json/wp/v2`;
}

export function getAuthorName(post: BlogPost): string {
  return post._embedded.author[0].name;
}

export function getFeaturedImageSrc(post: BlogPost, size: ImageSize): string {
  return getFeaturedImage(post, size).src;
}

export function getFeaturedImage(post: BlogPost, size: ImageSize): SourceImage {
  const { sizes } = post._embedded['wp:featuredmedia'][0].media_details;
  const image = sizes[size] || sizes['full'];
  image.src = image.source_url;
  return image;
}